// T-29 — Explore Firefly catalog phrase match + open telemetry.

export const FIREFLY_CATALOG_OPEN_EVENT = "bb-firefly-catalog-open";

/** Phrases that open the tour catalog instead of Ask/tour matching. */
export const FIREFLY_CATALOG_EXPLORE_QUERY =
  /\b(show me what firefly can do|what else can firefly do|what can firefly do|explore firefly)\b/i;

export function queryPrefersFireflyCatalog(query: string): boolean {
  return FIREFLY_CATALOG_EXPLORE_QUERY.test(query.trim());
}

export type FireflyCatalogOpenEventDetail = {
  source: "chip" | "ask";
  mode: string;
  tourCount: number;
  ts: number;
};

export function buildFireflyCatalogOpenEventDetail(input: {
  source: "chip" | "ask";
  mode: string;
  tourCount: number;
  nowMs: number;
}): FireflyCatalogOpenEventDetail {
  return {
    source: input.source,
    mode: input.mode,
    tourCount: input.tourCount,
    ts: input.nowMs,
  };
}

export function emitFireflyCatalogOpenEvent(detail: FireflyCatalogOpenEventDetail): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<FireflyCatalogOpenEventDetail>(FIREFLY_CATALOG_OPEN_EVENT, {
      detail,
    }),
  );
}
